function truncateBreadcrumbTitle() {
  const titleEl = document.querySelector(".breadcrumb__title");

  if (!titleEl) {
    return;
  }

  if (!titleEl.dataset.fullText) {
    titleEl.dataset.fullText = titleEl.textContent.trim();
  }

  const originalText = titleEl.dataset.fullText;
  titleEl.textContent = originalText;

  // Ensure the title only uses the remaining width in the breadcrumb row.
  titleEl.style.flex = "1 1 auto";
  titleEl.style.minWidth = "0";
  titleEl.style.display = "block";
  titleEl.style.whiteSpace = "nowrap";

  if (titleEl.scrollWidth <= titleEl.clientWidth) {
    return;
  }

  const suffix = "...";
  let left = 0;
  let right = originalText.length;
  let best = suffix;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const candidate = `${originalText.slice(0, mid).trimEnd()}${suffix}`;
    titleEl.textContent = candidate;

    if (titleEl.scrollWidth <= titleEl.clientWidth) {
      best = candidate;
      left = mid + 1;
    } else {
      right = mid - 1;
    }
  }

  titleEl.textContent = best;
}

window.addEventListener("load", function () {
  truncateBreadcrumbTitle();

  window.addEventListener("resize", truncateBreadcrumbTitle);
});
